import React from 'react';
import { Paper, Tooltip, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { D, Loading, SearchField } from '../include';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import moment from 'moment';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

moment.locale('pt_br');

export class Logs extends React.Component {
  constructor(props) {
    super(props);
    var start = dayjs();
    var end = start.subtract(7,'day'); 
    this.state = {
      dataini: end.format('YYYY-MM-DD'),
      datafim: start.format('YYYY-MM-DD'),
      selectedUserName: 'Todos',
      dataTable: [],
      rows: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      searchField: '',
    };
  }

  componentDidMount = () => {
    this.updateData({
      dataini: this.state.dataini,
      datafim: this.state.datafim,
      page: this.state.page,
      pageSize: this.state.pageSize,
      search: this.state.searchField,
    });
  };

  updateData = (params) => {
    this.setState({ loading: true });
    this.props.api
      .get('/logs', { params })
      .then((r) => {
        for (var row in r.logs) {
          var date = new Date(r.logs[row].created_at);
          r.logs[row].created_at = date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', timeZoneName: 'short' });
        }

        this.setState({
          dataini: params.dataini,
          datafim: params.datafim,
          dataTable: r.logs || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handlePageChange = (newPage) => {
    this.setState({ page: newPage }, () => {
      this.updateData({
        dataini: this.state.dataini,
        datafim: this.state.datafim,
        page: this.state.page,
        pageSize: this.state.pageSize,
        search: this.state.searchField,
      });
    });
  };

  handlePageSizeChange = (newPageSize) => {
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.updateData({
        dataini: this.state.dataini,
        datafim: this.state.datafim,
        page: this.state.page,
        pageSize: this.state.pageSize,
        search: this.state.searchField,
      });
    });
  };
  
    handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData({
        dataini: this.state.dataini,
        datafim: this.state.datafim,
        page: pageSizeChanged ? 0 : newpagemodel.page,
        pageSize: newpagemodel.pageSize,
        search: this.state.searchField,
      });
    });
  };
  
  

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData({
        dataini: this.state.dataini,
        datafim: this.state.datafim,
        page: 0,
        pageSize: this.state.pageSize,
        search: this.state.searchField,
      });
    });
  };

  render() {
    const { selectedUserName, dataTable, loading, page, pageSize, totalRows, searchField } = this.state;

    const columns = [
      { field: 'username', headerName: 'Usuário', flex: 1 },
      { field: 'url', headerName: 'Caminho', flex: 2 },
      { field: 'created_at', headerName: 'Criado em', flex: 1 },
    ];

    const filteredRows =
      selectedUserName && selectedUserName !== 'Todos'
        ? (dataTable || []).filter((row) => row.username === selectedUserName)
        : dataTable || [];

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
          />
          <Tooltip title="Pesquisar" arrow>
            <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
              <SearchIcon />
            </IconButton>
          </Tooltip>
      
          <D size="1rem" /> 
          
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Data inicial"
              format="DD/MM/YYYY"
              value={dayjs(this.state.dataini)}
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
              onChange={(newValue) =>
                this.updateData({
                  dataini: newValue.format('YYYY-MM-DD'),
                  datafim: this.state.datafim,
                  page: 0,
                  pageSize: this.state.pageSize,
                  search: this.state.searchField,
                })
              }
            />
          </LocalizationProvider>
          <D size="1rem" />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Data final"
              format="DD/MM/YYYY"
              value={dayjs(this.state.datafim)}
              slotProps={{ textField: { size: 'small', InputLabelProps: { shrink: true } } }}
              onChange={(newValue) =>
                this.updateData({
                  dataini: this.state.dataini,
                  datafim: newValue.format('YYYY-MM-DD'),
                  page: 0,
                  pageSize: this.state.pageSize,
                  search: this.state.searchField,
                })
              }
            />
          </LocalizationProvider>

        </D>

        <D h="1rem" />
      
        <Paper sx={{ height: '800px', width: '100%' }}>
          <DataGrid
            rows={filteredRows || []}
            columns={columns || []}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            getRowId={(row) => `${row.id}`}            
            
            
            components={{
              NoRowsOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>
                  Nenhum dado encontrado
                </D>
              ),
              LoadingOverlay: () => (
                <D style={{ padding: '2rem', textAlign: 'center' }}>
                  <Loading />
                </D>
              ),
            }}
          />
        </Paper>
      </D>
    );
  }
}
